
const Auth = (()=>{

    const _AuthConfig = ()=>{
        fetch('/sabios-module/user', {
            method: 'GET',
        }).then(response => response.json())
            .then(data => {
                if (data.error == true) {
                    //Hidden trivia options
                    document.querySelector('#trivia-questions') && (window.location.href = "/jugar");
                    document.querySelector('#trivia-test') && (window.location.href = "/jugar");
                    document.querySelector('#trivia-pages-error') && document.querySelector('#trivia-pages-error').classList.remove('hidden');
                    document.querySelector('#trivia-pages') && document.querySelector('#trivia-pages').classList.add('hidden');
                    //Header buttons
                    document.querySelector('.header__buttons').style.display = 'inherit';
                } else {
                    // Create a img element
                    if (data.userimage) {
                        const img = document.createElement('img');
                        img.src = data.userimage;
                        img.alt = data.name;
                        // Append the img element to the header__profile
                        document.querySelector('.header__profile').appendChild(img);
                    }
                    else {
                        // Create a circle with the first letter of the name
                        const div = document.createElement('div');
                        div.classList.add('circle');
                        div.innerHTML = data.name.charAt(0);
                        // Append the div element to the header__profile
                        document.querySelector('.header__profile').appendChild(div);
                    }
                    //Redirect
                    if(document.querySelector('#sabios-module-user-login') || document.querySelector('#sabios-module-user-register')){
                        window.location.href = '/';       
                    }
                    document.querySelector('.header__profile').style.display = 'inherit';
                    document.querySelector('#buttons-sticky').classList.add('hidden');
                }
            });
    }

    /*
    *Return child functions in a objects
    */
    return{
        setHandleEvent: function(){
            try { _AuthConfig(); } catch (error) { }
        }
    }
})();

/*
*Load global functions
*/
const loadAuthHandlers = ()=>{
    Auth.setHandleEvent();
}

export { loadAuthHandlers }